import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-sign-in-step-saler-localization',
  templateUrl: './sign-in-step-saler-localization.component.html',
  styleUrls: ['./sign-in-step-saler-localization.component.scss'],
})
export class SignInStepSalerLocalizationComponent {
  @Input() localizationForm!: FormGroup;
  @Input() submited = false;
  @Input() roadTypes: any[] = [];
  @Input() locations: any[] = [];
  @Input() provinces: any[] = [];
  @Input() countries: any[] = [];
  @Input() language = '';

  @Output() goToStep = new EventEmitter<number>();
}
